// extracted by mini-css-extract-plugin
export default {"footer-link":"footer_footer-link__O60mx","footer-branding":"footer_footer-branding__4fO12"};